import * as i0 from '@angular/core';
import { Directive, forwardRef, TemplateRef, Component, ChangeDetectionStrategy, Input, ViewChild, ContentChild, NgModule } from '@angular/core';
import * as i7 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/material/autocomplete';
import { MatAutocompleteTrigger, MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i2 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i1 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i8 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as i6 from '@firestitch/badge';
import { FsBadgeModule } from '@firestitch/badge';
import { email, filter } from '@firestitch/common';
import { findIndex, isEqual, isObject, remove } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import * as i5 from '@angular/material/core';

class FsAccountPickerResultDirective {
}
FsAccountPickerResultDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsAccountPickerResultDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsAccountPickerResultDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsAccountPickerResultDirective, selector: "[fs-account-picker-result]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsAccountPickerResultDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fs-account-picker-result]'
                }]
        }] });

function getAttributeValue(attribute, mapping) {
    if (!mapping) {
        return null;
    }
    return _getAttributeValue(attribute, mapping.split('.'));
}
function _getAttributeValue(value, indexes) {
    const index = indexes.shift(indexes);
    if (!index) {
        return value;
    }
    if (!value) {
        return value;
    }
    value = value[index];
    return _getAttributeValue(value, indexes);
}

const FS_ACCOUNT_PICKER_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FsAccountPickerComponent),
    multi: true
};
class FsAccountPickerComponent {
    constructor(_cdRef) {
        this._cdRef = _cdRef;
        this.search = null;
        this.label = '';
        this.nameProperty = 'name';
        this.imageProperty = 'image';
        this.keywordField = 'email';
        this.delay = 300;
        this.validateKeyword = keyword => {
            return email(keyword);
        };
        this.isValidKeyword = false;
        this.searchData = [];
        this.newData = {};
        this.keyword = null;
        this.keyword$ = new Subject();
        this._model = [];
        this.destroy$ = new Subject();
        this.searchInput = null;
        this.autocompleteSearch = null;
        this.autocompleteTrigger = null;
        this.templateRef = null;
        this._onTouched = () => { };
        this._onChange = (value) => { };
        this.onFocused = (event) => { };
    }
    get model() {
        return this._model;
    }
    registerOnChange(fn) { this._onChange = fn; }
    registerOnTouched(fn) { this._onTouched = fn; }
    ngOnInit() {
        this.keyword$
            .pipe(takeUntil(this.destroy$), debounceTime(this.delay))
            .subscribe(() => {
            this.onKeyUp();
            this._cdRef.markForCheck();
        });
        this.keyword$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
            this.newData = {};
            if (this.validateKeyword(this.keyword)) {
                this.newData = { type: 'email', email: this.keyword };
            }
            this._cdRef.markForCheck();
        });
    }
    addEmail(email) {
        this._model.push({ type: 'email', email: email });
    }
    blur() {
        setTimeout(() => {
            if (this.validateKeyword(this.keyword)) {
                this.addEmail(this.keyword);
            }
            this.clearInput();
            this._cdRef.markForCheck();
        });
    }
    onKeyUp() {
        this.searchData = [];
        if (!this.keyword) {
            return;
        }
        const comma = this.keyword.match(',');
        if (comma) {
            this.keyword.split(',').forEach(email => {
                if (this.validateKeyword(email)) {
                    this.addEmail(email.trim());
                }
            });
            return this.clearInput();
        }
        this.search(this.keyword)
            .pipe(takeUntil(this.destroy$))
            .subscribe(response => {
            this.searchData = response.map(data => {
                return {
                    type: 'account',
                    account: data,
                    name: getAttributeValue(data, this.nameProperty),
                    image: getAttributeValue(data, this.imageProperty)
                };
            });
            this.searchData = filter(this.searchData, item => {
                return findIndex(this._model, (model) => {
                    return isEqual(model, item);
                }) === -1;
            });
            this._cdRef.markForCheck();
        });
    }
    onSelect(data) {
        this.searchData = [];
        if (isObject(data)) {
            if (!filter(this._model, data).length) {
                this.writeValue([...this._model, data]);
            }
            this.clearInput();
        }
    }
    clearInput() {
        this.searchInput.nativeElement.value = '';
        this.keyword = '';
    }
    onRemove(data) {
        remove(this._model, data);
        this.writeValue(this._model, true);
    }
    writeValue(value, allowEmpty = false) {
        value = Array.isArray(value) ? value : [];
        if (!allowEmpty && !value.length) {
            return;
        }
        this._model = value;
        this._onChange(this._model);
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
FsAccountPickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsAccountPickerComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsAccountPickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsAccountPickerComponent, selector: "fs-account-picker", inputs: { search: "search", label: "label", nameProperty: "nameProperty", imageProperty: "imageProperty", keywordField: "keywordField", delay: "delay", validateKeyword: "validateKeyword" }, providers: [FS_ACCOUNT_PICKER_ACCESSOR], queries: [{ propertyName: "templateRef", first: true, predicate: FsAccountPickerResultDirective, descendants: true, read: TemplateRef }], viewQueries: [{ propertyName: "searchInput", first: true, predicate: ["searchInput"], descendants: true, static: true }, { propertyName: "autocompleteSearch", first: true, predicate: ["autocompleteSearch"], descendants: true, static: true }, { propertyName: "autocompleteTrigger", first: true, predicate: MatAutocompleteTrigger, descendants: true, static: true }], ngImport: i0, template: "<mat-form-field>\n  <mat-chip-list #searchList>\n    <mat-chip\n      *ngFor=\"let item of model\"\n      [selectable]=\"true\"\n      [removable]=\"true\"\n      (removed)=\"onRemove(item)\">\n        <ng-container\n          [ngTemplateOutlet]=\"itemTemplate\"\n          [ngTemplateOutletContext]=\"{ item: item }\">\n        </ng-container>\n      <mat-icon matChipRemove>cancel</mat-icon>\n    </mat-chip>\n    <input\n      #searchInput\n      placeholder=\"{{label}}\"\n      [(ngModel)]=\"keyword\"\n      (ngModelChange)=\"onSelect($event)\"\n      (keyup)=\"keyword$.next(keyword)\"\n      (blur)=\"blur()\"\n      name=\"keyword\"\n      [matAutocomplete]=\"autocompleteSearch\"\n      [matChipInputFor]=\"searchList\"\n      [matChipInputAddOnBlur]=\"true\">\n  </mat-chip-list>\n  <mat-autocomplete\n    #autocompleteSearch=\"matAutocomplete\"\n    class=\"fs-account-picker-autocomplete\"\n    autoActiveFirstOption=\"true\">\n    <!-- <mat-optgroup *ngIf=\"searchData.length\" label=\"Select Account\"></mat-optgroup> -->\n\n    <mat-option *ngFor=\"let item of searchData\" [value]=\"item\">\n      <ng-container\n        [ngTemplateOutlet]=\"itemTemplate\"\n        [ngTemplateOutletContext]=\"{ item: item }\">\n      </ng-container>\n    </mat-option>\n\n    <ng-container *ngIf=\"keyword\">\n      <!-- <mat-optgroup label=\"Add new person by email\"></mat-optgroup> -->\n\n      <mat-option *ngIf=\"!newData.type\" disabled class=\"invalid-email-preview\">\n        <div>{{ keyword }}</div>\n        <small>Invalid email address</small>\n      </mat-option>\n\n      <mat-option *ngIf=\"newData.type==='email'\" [value]=\"newData\">\n\n        <ng-container\n          [ngTemplateOutlet]=\"itemTemplate\"\n          [ngTemplateOutletContext]=\"{ item: newData }\">\n        </ng-container>\n      </mat-option>\n\n    </ng-container>\n  </mat-autocomplete>\n</mat-form-field>\n\n<ng-template let-item=\"item\" #itemTemplate>\n  <div *ngIf=\"item.type==='account'\" class=\"item-template\">\n    <fs-badge [image]=\"item.image\" size=\"32\"></fs-badge>\n    <div>\n      {{item.name}}\n    </div>\n  </div>\n\n  <div *ngIf=\"item.type==='email'\">\n    {{item.email}}\n  </div>\n</ng-template>", styles: [":host mat-form-field{width:100%}:host .item-template fs-badge{margin-left:-12px}::ng-deep .fs-account-picker-autocomplete mat-option{line-height:normal}::ng-deep .fs-account-picker-autocomplete .invalid-email-preview{line-height:normal}::ng-deep .fs-account-picker-autocomplete .item-template,:host .item-template{display:flex;flex-direction:row;align-items:center}::ng-deep .fs-account-picker-autocomplete .item-template fs-badge,:host .item-template fs-badge{margin-right:10px;display:flex}\n"], components: [{ type: i1.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i2.MatChipList, selector: "mat-chip-list", inputs: ["aria-orientation", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "selectable", "tabIndex", "errorStateMatcher"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i4.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { type: i5.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i6.FsBadgeComponent, selector: "fs-badge", inputs: ["color", "text", "tooltip", "size", "shape", "image", "icon", "iconSize", "iconColor", "backgroundSize"] }], directives: [{ type: i7.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { type: i7.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i2.MatChipRemove, selector: "[matChipRemove]" }, { type: i8.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i4.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i2.MatChipInput, selector: "input[matChipInputFor]", inputs: ["matChipInputSeparatorKeyCodes", "placeholder", "id", "matChipInputFor", "matChipInputAddOnBlur", "disabled"], outputs: ["matChipInputTokenEnd"], exportAs: ["matChipInput", "matChipInputFor"] }, { type: i8.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i8.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i7.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsAccountPickerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-account-picker',
                    templateUrl: './account-picker.component.html',
                    styleUrls: ['./account-picker.component.scss'],
                    providers: [FS_ACCOUNT_PICKER_ACCESSOR],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { search: [{
                type: Input
            }], label: [{
                type: Input
            }], nameProperty: [{
                type: Input
            }], imageProperty: [{
                type: Input
            }], keywordField: [{
                type: Input
            }], delay: [{
                type: Input
            }], validateKeyword: [{
                type: Input
            }], searchInput: [{
                type: ViewChild,
                args: ['searchInput', { static: true }]
            }], autocompleteSearch: [{
                type: ViewChild,
                args: ['autocompleteSearch', { static: true }]
            }], autocompleteTrigger: [{
                type: ViewChild,
                args: [MatAutocompleteTrigger, { static: true }]
            }], templateRef: [{
                type: ContentChild,
                args: [FsAccountPickerResultDirective, { read: TemplateRef }]
            }] } });

class FsAccountPickerModule {
}
FsAccountPickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsAccountPickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsAccountPickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsAccountPickerModule, declarations: [FsAccountPickerComponent,
        FsAccountPickerResultDirective], imports: [CommonModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatIconModule,
        MatFormFieldModule,
        FormsModule,
        FsBadgeModule], exports: [FsAccountPickerComponent,
        FsAccountPickerResultDirective] });
FsAccountPickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsAccountPickerModule, providers: [], imports: [[
            CommonModule,
            MatChipsModule,
            MatAutocompleteModule,
            MatIconModule,
            MatFormFieldModule,
            FormsModule,
            FsBadgeModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsAccountPickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatChipsModule,
                        MatAutocompleteModule,
                        MatIconModule,
                        MatFormFieldModule,
                        FormsModule,
                        FsBadgeModule
                    ],
                    exports: [
                        FsAccountPickerComponent,
                        FsAccountPickerResultDirective
                    ],
                    entryComponents: [],
                    declarations: [
                        FsAccountPickerComponent,
                        FsAccountPickerResultDirective,
                    ],
                    providers: [],
                }]
        }] });

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FsAccountPickerComponent, FsAccountPickerModule, FsAccountPickerResultDirective };
